import React, {useEffect, useState} from "react";
import {useFetchHook} from "../../hooks/useFetchHook";
import fetcher from "../../fetcher";
import useDidMountEffect from "../../hooks/useDidMountEffect";
import {BaseModal} from "../../components/BaseModal";
import {formatDate} from "../../utils/utils";
import {useThemeStore} from "../../stores/themeStore";

// The BaseModal wrapper stays transparent; the .DealRebateModal card paints its
// own themed surface (data-theme selects the palette block in SCSS), matching the
// DeskingPage / CalculatePage redesign.
const wrapperStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: 'transparent',
    boxShadow: 'none',
    outline: 'none',
    padding: 0,
};

export const DealRebateModal = ( {name, description, expirationDate, isOpen, setIsOpen, rebate} ) => {
    const theme = useThemeStore((state) => state.theme)
    const [rebateState, setRebateState] = useState(rebate)
    const [getRebateResponse, getRebate] = useFetchHook(fetcher.getRebate)

    useEffect(function fetchRebate(){
        getRebate(rebate.external_id)
    }, [])

    useDidMountEffect(function setFetchedRebate() {
        if (getRebateResponse && getRebateResponse?.data?.data) {
            setRebateState({...rebateState, full_description: getRebateResponse?.data?.data})
        }
    }, [getRebateResponse])

    if (!rebateState.full_description) return null;

    const full_description = rebateState.full_description

    return (
        <BaseModal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            style={wrapperStyle}
        >
            <div className={'DealRebateModal'} data-theme={theme}>
                <button
                    type="button"
                    className={'DealRebateModal__close'}
                    aria-label={'Close'}
                    onClick={() => setIsOpen(null)}
                >
                    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
                         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="6" y1="6" x2="18" y2="18"/>
                        <line x1="18" y1="6" x2="6" y2="18"/>
                    </svg>
                </button>

                <div className={'DealRebateModal__header'}>
                    <span className={'DealRebateModal__title'}>{name}</span>
                    {
                        expirationDate &&
                        <span className={'DealRebateModal__expires'}>
                            Expires {formatDate(new Date(expirationDate))}
                        </span>
                    }
                </div>

                <div className={'DealRebateModal__divider'}/>

                <div className={'DealRebateModal__row'}>
                    <span className={'DealRebateModal__label'}>Amount</span>
                    <span className={'DealRebateModal__value'}>{rebateState.amount}</span>
                </div>

                <div className={'DealRebateModal__row DealRebateModal__row--block'}>
                    <span className={'DealRebateModal__label'}>Eligibility</span>
                    <span className={'DealRebateModal__value'}>{full_description}</span>
                </div>
            </div>
        </BaseModal>
    )
}
